// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
   Events Page — Wedding Editorial Style
   ============================================= */

.ep-page {
  background: #FAFAF7;
  color: #2C1810;
  padding-top: 76px; /* navbar offset */
  padding-bottom: 80px;
  min-height: 100vh;
  font-family: inherit;
}

/* ── Page header ── */
.ep-header {
  text-align: center;
  padding: 64px 24px 52px;
  max-width: 660px;
  margin: 0 auto;
  animation: epFadeUp 0.55s ease both;
}

@keyframes epFadeUp {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}

.ep-ornament {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, transparent, #C8A97A, transparent);
  margin: 0 auto 28px;
}

.ep-title {
  font-family: 'Playfair Display', serif;
  font-size: 2.7rem;
  font-weight: 300;
  letter-spacing: 0.03em;
  color: #2C1810;
  margin: 0 0 18px;
  line-height: 1.18;
}

@media (max-width: 600px) {
  .ep-title { font-size: 2rem; }
}

@media (min-width: 601px) and (max-width: 960px) {
  .ep-title { font-size: 2.2rem; }
}

.ep-lead {
  font-size: 1.02rem;
  line-height: 1.85;
  color: #6B4C3B;
  margin: 0 auto;
}

/* ── Main two-column ── */
.ep-main {
  display: grid;
  grid-template-columns: 9fr 10fr;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 40px;
  align-items: start;
  gap: 0;
  animation: epFadeUp 0.55s 0.15s ease both;
}

/* ── Left: stacked photos ── */
.ep-photos-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 36px;
}

.ep-photo {
  display: block;
  overflow: hidden;
  background: #E8DDD0;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 100%;
}

.ep-photo picture,
.ep-strip-photo picture {
  display: block;
  width: 100%;
  height: 100%;
}

.ep-photo img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  aspect-ratio: 4 / 5;
  transition: transform 0.55s ease, filter 0.3s ease;
  filter: brightness(0.96) saturate(0.95);
}

.ep-photo:hover img {
  transform: scale(1.04);
  filter: brightness(1) saturate(1);
}

/* ── Right: offer card ── */
.ep-offer-col {
  position: sticky;
  top: 96px;
}

.ep-offer {
  background: #fff;
  border: 1px solid #E8DDD0;
  padding: 44px 40px;
}

.ep-offer-eyebrow {
  font-size: 0.68rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #C8A97A;
  margin: 0 0 10px;
}

.ep-offer-title {
  font-family: 'Playfair Display', serif;
  font-size: 1.9rem;
  font-weight: 400;
  color: #2C1810;
  margin: 0 0 16px;
  padding-bottom: 18px;
  border-bottom: 1px solid #E8DDD0;
  line-height: 1.2;
}

.ep-offer-intro {
  font-style: italic;
  color: #6B4C3B;
  font-size: 0.93rem;
  line-height: 1.8;
  margin: 0 0 24px;
}

/* ── Offer table ── */
.ep-offer-table {
  margin-bottom: 28px;
}

.ep-offer-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
  padding: 11px 0;
  border-bottom: 1px solid #F0E9E0;
  font-size: 0.9rem;
}

.ep-offer-row--hl {
  background: #FDF8F2;
  padding: 13px 10px;
  margin: 0 -10px;
  border-bottom: 1px solid #F0E9E0;
  display: block;
}

.ep-offer-hl-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ep-offer-hl-top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
}

.ep-offer-hl-sub {
  font-size: 0.83rem;
  color: #6B4C3B;
  line-height: 1.65;
  margin: 0;
  font-style: italic;
}

.ep-offer-desc {
  color: #3D2A20;
  flex: 1;
  line-height: 1.5;
}

.ep-offer-val {
  font-family: 'Playfair Display', serif;
  font-size: 1.05rem;
  font-weight: 600;
  color: #7B2323;
  white-space: nowrap;
  flex-shrink: 0;
  letter-spacing: 0.02em;
}

.ep-offer-val--free {
  color: #3A6B46;
  font-style: italic;
  font-weight: 400;
}

/* ── CTA ── */
.ep-offer-cta {
  border-top: 1px solid #E8DDD0;
  padding-top: 22px;
  margin-bottom: 22px;
}

.ep-offer-cta p {
  font-size: 0.88rem;
  color: #6B4C3B;
  line-height: 1.75;
  margin: 0 0 14px;
}

.ep-cta-btn {
  width: 100%;
  padding: 13px 24px;
  background: #2C1810;
  color: #F5EDE0;
  border: none;
  font-family: 'Playfair Display', serif;
  font-size: 0.93rem;
  font-style: italic;
  letter-spacing: 0.06em;
  cursor: pointer;
  transition: background 0.3s ease;
}

.ep-cta-btn:hover {
  background: #7B2323;
}

.ep-cta-btn--inline {
  width: auto;
  padding: 9px 18px;
  font-size: 0.85rem;
  align-self: flex-start;
}

/* ── Contact ── */
.ep-offer-contact {
  font-size: 0.83rem;
  color: #6B4C3B;
  line-height: 1.8;
}

.ep-offer-contact p {
  font-style: italic;
  margin: 0 0 4px;
}

.ep-contact-links {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.ep-contact-links a {
  color: #7B2323;
  text-decoration: none;
  font-weight: 500;
}

.ep-contact-links a:hover {
  text-decoration: underline;
}

.ep-contact-sep {
  color: #C8A97A;
}

/* ── Bottom photo strip ── */
.ep-strip {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  max-width: 1180px;
  margin: 8px auto 0;
  padding: 0 40px;
}

.ep-strip-photo {
  display: block;
  overflow: hidden;
  background: #E8DDD0;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 100%;
}

.ep-strip-photo img {
  width: 100%;
  display: block;
  object-fit: cover;
  aspect-ratio: 3 / 2;
  transition: transform 0.55s ease, filter 0.3s ease;
  filter: brightness(0.96) saturate(0.95);
}

.ep-strip-photo:hover img {
  transform: scale(1.04);
  filter: brightness(1) saturate(1);
}

/* ── SEO block ── */
.ep-seo {
  max-width: 760px;
  margin: 64px auto 0;
  padding: 48px 40px 0;
  text-align: center;
  border-top: 1px solid #E8DDD0;
}

.ep-seo h3 {
  font-family: 'Playfair Display', serif;
  font-size: 1.25rem;
  font-weight: 400;
  color: #2C1810;
  margin: 0 0 14px;
  letter-spacing: 0.02em;
}

.ep-seo p {
  font-size: 0.9rem;
  line-height: 1.95;
  color: #6B4C3B;
  margin: 0;
}

.ep-seo-link {
  color: #7B2323;
  text-decoration: none;
  border-bottom: 1px solid rgba(123, 35, 35, 0.35);
  transition: border-color 0.2s ease;
}

.ep-seo-link:hover {
  border-color: #7B2323;
}

/* ── Lightbox ── */
.ep-lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.96);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: epFade 0.22s ease;
}

@keyframes epFade {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.ep-lb-inner {
  position: relative;
  width: 90vw;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ep-lb-img-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ep-lb-img-wrap img {
  max-width: 88vw;
  max-height: 84vh;
  object-fit: contain;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.ep-lb-counter {
  position: absolute;
  bottom: -42px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(250, 245, 235, 0.6);
  font-size: 0.85rem;
  white-space: nowrap;
  letter-spacing: 0.1em;
}

.ep-lb-close,
.ep-lb-prev,
.ep-lb-next {
  position: absolute;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #FAF5EB;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s ease, background 0.2s ease;
  z-index: 10001;
}

.ep-lb-close {
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  font-size: 1rem;
}

.ep-lb-prev,
.ep-lb-next {
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  font-size: 2rem;
  line-height: 1;
}

.ep-lb-prev { left: 16px; }
.ep-lb-next { right: 16px; }

.ep-lb-close:hover,
.ep-lb-prev:hover:not(:disabled),
.ep-lb-next:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.65);
}

.ep-lb-prev:disabled,
.ep-lb-next:disabled {
  opacity: 0.18;
  cursor: not-allowed;
}

/* ── Responsive ── */

@media (max-width: 960px) {
  .ep-main {
    grid-template-columns: 1fr;
    padding: 0 28px;
  }

  .ep-photos-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-right: 0;
  }

  .ep-photo img {
    aspect-ratio: 3 / 4;
  }

  .ep-offer-col {
    position: static;
  }

  .ep-strip {
    padding: 0 28px;
  }

  .ep-seo {
    padding: 40px 28px 0;
  }
}

@media (max-width: 600px) {
  .ep-page { padding-top: 68px; }
  .ep-header { padding: 44px 18px 36px; }

  .ep-main { padding: 0 16px; }
  .ep-photos-col { grid-template-columns: 1fr; gap: 6px; }
  .ep-photo img { aspect-ratio: 5 / 4; }

  .ep-offer { padding: 30px 22px; }

  .ep-strip { grid-template-columns: 1fr; padding: 0 16px; }
  .ep-strip-photo img { aspect-ratio: 4 / 3; }

  .ep-seo { padding: 36px 16px 0; }

  .ep-text-crosslinks { padding: 16px 16px 40px; }
}

/* ── Cross-links (plain text) ── */
.ep-text-crosslinks {
  max-width: 860px;
  margin: 0 auto;
  padding: 20px 28px 56px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ep-text-crosslinks p {
  font-size: 0.97rem;
  color: #6b5050;
  line-height: 1.6;
  margin: 0;
}

.ep-text-link {
  color: #7b2323;
  text-decoration: underline;
  text-underline-offset: 3px;
  font-weight: 500;
  transition: color .2s;
}

.ep-text-link:hover { color: #5a1a1a; }

/* ── Wooden boxes note inside highlighted row ── */
.ep-offer-boxes-note {
  margin: 10px 0 0;
  font-size: 0.82rem;
  color: #9a7070;
  line-height: 1.5;
}

.ep-offer-boxes-link {
  color: #9a7070;
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: color .2s;
}

.ep-offer-boxes-link:hover { color: #7b5050; }

.ep-offer-boxes-link--btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
}

/* ── Box modal image ── */
.ep-lb-inner--img-only {
  padding: 0;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  max-height: calc(100vh - 80px);
  width: auto;
}

.ep-lb-inner--img-only .ep-lb-close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  background: rgba(0,0,0,.45);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ep-lb-box-img {
  display: block;
  width: auto;
  height: auto;
  max-height: calc(100vh - 80px);
  max-width: calc(100vw - 48px);
  border-radius: 12px;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/components/EventsPage.css"],"names":[],"mappings":"AAAA;;kDAEkD;;AAElD;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB,EAAE,kBAAkB;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY,eAAe,EAAE;AAC/B;;AAEA;EACE,YAAY,iBAAiB,EAAE;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;EAClD,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;EAClD,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,kBAAkB;EAClB,uBAAuB;EACvB,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc,UAAU,EAAE;AAC1B,cAAc,WAAW,EAAE;;AAE3B;;;EAGE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB;EACE;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW,iBAAiB,EAAE;EAC9B,aAAa,uBAAuB,EAAE;;EAEtC,WAAW,eAAe,EAAE;EAC5B,iBAAiB,0BAA0B,EAAE,QAAQ,EAAE;EACvD,gBAAgB,mBAAmB,EAAE;;EAErC,YAAY,kBAAkB,EAAE;;EAEhC,YAAY,0BAA0B,EAAE,eAAe,EAAE;EACzD,sBAAsB,mBAAmB,EAAE;;EAE3C,UAAU,oBAAoB,EAAE;;EAEhC,sBAAsB,uBAAuB,EAAE;AACjD;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sBAAsB,cAAc,EAAE;;AAEtC,mDAAmD;AACnD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,6BAA6B,cAAc,EAAE;;AAE7C;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":["/* =============================================\n   Events Page — Wedding Editorial Style\n   ============================================= */\n\n.ep-page {\n  background: #FAFAF7;\n  color: #2C1810;\n  padding-top: 76px; /* navbar offset */\n  padding-bottom: 80px;\n  min-height: 100vh;\n  font-family: inherit;\n}\n\n/* ── Page header ── */\n.ep-header {\n  text-align: center;\n  padding: 64px 24px 52px;\n  max-width: 660px;\n  margin: 0 auto;\n  animation: epFadeUp 0.55s ease both;\n}\n\n@keyframes epFadeUp {\n  from { opacity: 0; transform: translateY(24px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.ep-ornament {\n  width: 60px;\n  height: 3px;\n  background: linear-gradient(90deg, transparent, #C8A97A, transparent);\n  margin: 0 auto 28px;\n}\n\n.ep-title {\n  font-family: 'Playfair Display', serif;\n  font-size: 2.7rem;\n  font-weight: 300;\n  letter-spacing: 0.03em;\n  color: #2C1810;\n  margin: 0 0 18px;\n  line-height: 1.18;\n}\n\n@media (max-width: 600px) {\n  .ep-title { font-size: 2rem; }\n}\n\n@media (min-width: 601px) and (max-width: 960px) {\n  .ep-title { font-size: 2.2rem; }\n}\n\n.ep-lead {\n  font-size: 1.02rem;\n  line-height: 1.85;\n  color: #6B4C3B;\n  margin: 0 auto;\n}\n\n/* ── Main two-column ── */\n.ep-main {\n  display: grid;\n  grid-template-columns: 9fr 10fr;\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 0 40px;\n  align-items: start;\n  gap: 0;\n  animation: epFadeUp 0.55s 0.15s ease both;\n}\n\n/* ── Left: stacked photos ── */\n.ep-photos-col {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-right: 36px;\n}\n\n.ep-photo {\n  display: block;\n  overflow: hidden;\n  background: #E8DDD0;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  width: 100%;\n}\n\n.ep-photo picture,\n.ep-strip-photo picture {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.ep-photo img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  aspect-ratio: 4 / 5;\n  transition: transform 0.55s ease, filter 0.3s ease;\n  filter: brightness(0.96) saturate(0.95);\n}\n\n.ep-photo:hover img {\n  transform: scale(1.04);\n  filter: brightness(1) saturate(1);\n}\n\n/* ── Right: offer card ── */\n.ep-offer-col {\n  position: sticky;\n  top: 96px;\n}\n\n.ep-offer {\n  background: #fff;\n  border: 1px solid #E8DDD0;\n  padding: 44px 40px;\n}\n\n.ep-offer-eyebrow {\n  font-size: 0.68rem;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: #C8A97A;\n  margin: 0 0 10px;\n}\n\n.ep-offer-title {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.9rem;\n  font-weight: 400;\n  color: #2C1810;\n  margin: 0 0 16px;\n  padding-bottom: 18px;\n  border-bottom: 1px solid #E8DDD0;\n  line-height: 1.2;\n}\n\n.ep-offer-intro {\n  font-style: italic;\n  color: #6B4C3B;\n  font-size: 0.93rem;\n  line-height: 1.8;\n  margin: 0 0 24px;\n}\n\n/* ── Offer table ── */\n.ep-offer-table {\n  margin-bottom: 28px;\n}\n\n.ep-offer-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 16px;\n  padding: 11px 0;\n  border-bottom: 1px solid #F0E9E0;\n  font-size: 0.9rem;\n}\n\n.ep-offer-row--hl {\n  background: #FDF8F2;\n  padding: 13px 10px;\n  margin: 0 -10px;\n  border-bottom: 1px solid #F0E9E0;\n  display: block;\n}\n\n.ep-offer-hl-body {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ep-offer-hl-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 16px;\n}\n\n.ep-offer-hl-sub {\n  font-size: 0.83rem;\n  color: #6B4C3B;\n  line-height: 1.65;\n  margin: 0;\n  font-style: italic;\n}\n\n.ep-offer-desc {\n  color: #3D2A20;\n  flex: 1;\n  line-height: 1.5;\n}\n\n.ep-offer-val {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #7B2323;\n  white-space: nowrap;\n  flex-shrink: 0;\n  letter-spacing: 0.02em;\n}\n\n.ep-offer-val--free {\n  color: #3A6B46;\n  font-style: italic;\n  font-weight: 400;\n}\n\n/* ── CTA ── */\n.ep-offer-cta {\n  border-top: 1px solid #E8DDD0;\n  padding-top: 22px;\n  margin-bottom: 22px;\n}\n\n.ep-offer-cta p {\n  font-size: 0.88rem;\n  color: #6B4C3B;\n  line-height: 1.75;\n  margin: 0 0 14px;\n}\n\n.ep-cta-btn {\n  width: 100%;\n  padding: 13px 24px;\n  background: #2C1810;\n  color: #F5EDE0;\n  border: none;\n  font-family: 'Playfair Display', serif;\n  font-size: 0.93rem;\n  font-style: italic;\n  letter-spacing: 0.06em;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.ep-cta-btn:hover {\n  background: #7B2323;\n}\n\n.ep-cta-btn--inline {\n  width: auto;\n  padding: 9px 18px;\n  font-size: 0.85rem;\n  align-self: flex-start;\n}\n\n/* ── Contact ── */\n.ep-offer-contact {\n  font-size: 0.83rem;\n  color: #6B4C3B;\n  line-height: 1.8;\n}\n\n.ep-offer-contact p {\n  font-style: italic;\n  margin: 0 0 4px;\n}\n\n.ep-contact-links {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.ep-contact-links a {\n  color: #7B2323;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.ep-contact-links a:hover {\n  text-decoration: underline;\n}\n\n.ep-contact-sep {\n  color: #C8A97A;\n}\n\n/* ── Bottom photo strip ── */\n.ep-strip {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  max-width: 1180px;\n  margin: 8px auto 0;\n  padding: 0 40px;\n}\n\n.ep-strip-photo {\n  display: block;\n  overflow: hidden;\n  background: #E8DDD0;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  width: 100%;\n}\n\n.ep-strip-photo img {\n  width: 100%;\n  display: block;\n  object-fit: cover;\n  aspect-ratio: 3 / 2;\n  transition: transform 0.55s ease, filter 0.3s ease;\n  filter: brightness(0.96) saturate(0.95);\n}\n\n.ep-strip-photo:hover img {\n  transform: scale(1.04);\n  filter: brightness(1) saturate(1);\n}\n\n/* ── SEO block ── */\n.ep-seo {\n  max-width: 760px;\n  margin: 64px auto 0;\n  padding: 48px 40px 0;\n  text-align: center;\n  border-top: 1px solid #E8DDD0;\n}\n\n.ep-seo h3 {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.25rem;\n  font-weight: 400;\n  color: #2C1810;\n  margin: 0 0 14px;\n  letter-spacing: 0.02em;\n}\n\n.ep-seo p {\n  font-size: 0.9rem;\n  line-height: 1.95;\n  color: #6B4C3B;\n  margin: 0;\n}\n\n.ep-seo-link {\n  color: #7B2323;\n  text-decoration: none;\n  border-bottom: 1px solid rgba(123, 35, 35, 0.35);\n  transition: border-color 0.2s ease;\n}\n\n.ep-seo-link:hover {\n  border-color: #7B2323;\n}\n\n/* ── Lightbox ── */\n.ep-lightbox {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.96);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: epFade 0.22s ease;\n}\n\n@keyframes epFade {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.ep-lb-inner {\n  position: relative;\n  width: 90vw;\n  height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ep-lb-img-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ep-lb-img-wrap img {\n  max-width: 88vw;\n  max-height: 84vh;\n  object-fit: contain;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.ep-lb-counter {\n  position: absolute;\n  bottom: -42px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: rgba(250, 245, 235, 0.6);\n  font-size: 0.85rem;\n  white-space: nowrap;\n  letter-spacing: 0.1em;\n}\n\n.ep-lb-close,\n.ep-lb-prev,\n.ep-lb-next {\n  position: absolute;\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  color: #FAF5EB;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: border-color 0.2s ease, background 0.2s ease;\n  z-index: 10001;\n}\n\n.ep-lb-close {\n  top: 16px;\n  right: 16px;\n  width: 40px;\n  height: 40px;\n  font-size: 1rem;\n}\n\n.ep-lb-prev,\n.ep-lb-next {\n  top: 50%;\n  transform: translateY(-50%);\n  width: 50px;\n  height: 50px;\n  font-size: 2rem;\n  line-height: 1;\n}\n\n.ep-lb-prev { left: 16px; }\n.ep-lb-next { right: 16px; }\n\n.ep-lb-close:hover,\n.ep-lb-prev:hover:not(:disabled),\n.ep-lb-next:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.65);\n}\n\n.ep-lb-prev:disabled,\n.ep-lb-next:disabled {\n  opacity: 0.18;\n  cursor: not-allowed;\n}\n\n/* ── Responsive ── */\n\n@media (max-width: 960px) {\n  .ep-main {\n    grid-template-columns: 1fr;\n    padding: 0 28px;\n  }\n\n  .ep-photos-col {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    padding-right: 0;\n  }\n\n  .ep-photo img {\n    aspect-ratio: 3 / 4;\n  }\n\n  .ep-offer-col {\n    position: static;\n  }\n\n  .ep-strip {\n    padding: 0 28px;\n  }\n\n  .ep-seo {\n    padding: 40px 28px 0;\n  }\n}\n\n@media (max-width: 600px) {\n  .ep-page { padding-top: 68px; }\n  .ep-header { padding: 44px 18px 36px; }\n\n  .ep-main { padding: 0 16px; }\n  .ep-photos-col { grid-template-columns: 1fr; gap: 6px; }\n  .ep-photo img { aspect-ratio: 5 / 4; }\n\n  .ep-offer { padding: 30px 22px; }\n\n  .ep-strip { grid-template-columns: 1fr; padding: 0 16px; }\n  .ep-strip-photo img { aspect-ratio: 4 / 3; }\n\n  .ep-seo { padding: 36px 16px 0; }\n\n  .ep-text-crosslinks { padding: 16px 16px 40px; }\n}\n\n/* ── Cross-links (plain text) ── */\n.ep-text-crosslinks {\n  max-width: 860px;\n  margin: 0 auto;\n  padding: 20px 28px 56px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ep-text-crosslinks p {\n  font-size: 0.97rem;\n  color: #6b5050;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.ep-text-link {\n  color: #7b2323;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  font-weight: 500;\n  transition: color .2s;\n}\n\n.ep-text-link:hover { color: #5a1a1a; }\n\n/* ── Wooden boxes note inside highlighted row ── */\n.ep-offer-boxes-note {\n  margin: 10px 0 0;\n  font-size: 0.82rem;\n  color: #9a7070;\n  line-height: 1.5;\n}\n\n.ep-offer-boxes-link {\n  color: #9a7070;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  transition: color .2s;\n}\n\n.ep-offer-boxes-link:hover { color: #7b5050; }\n\n.ep-offer-boxes-link--btn {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: inherit;\n  font-family: inherit;\n}\n\n/* ── Box modal image ── */\n.ep-lb-inner--img-only {\n  padding: 0;\n  border-radius: 12px;\n  overflow: hidden;\n  position: relative;\n  max-height: calc(100vh - 80px);\n  width: auto;\n}\n\n.ep-lb-inner--img-only .ep-lb-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 10;\n  background: rgba(0,0,0,.45);\n  border: none;\n  color: #fff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  font-size: 1rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ep-lb-box-img {\n  display: block;\n  width: auto;\n  height: auto;\n  max-height: calc(100vh - 80px);\n  max-width: calc(100vw - 48px);\n  border-radius: 12px;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
